export const ROLES: Record<RolesUnion, RolesUnion> = {
  Parent: 'Parent',
  Specialist: 'Specialist',
  CampDirector: 'CampDirector'
} as const
